module.exports = __webpack_public_path__ + "img/th.484369a1.gif";